import { MILESTONE_LEVELS } from '../config/exploreUnknownLevelingMilestones';

/**
 * Milestone levels newly reached on this XP grant (server `newMilestones` or client fallback).
 * @param {object|null|undefined} grant
 * @returns {number[]}
 */
export function getNewMilestonesFromGrant(grant) {
  if (!grant) {
    return [];
  }
  if (Array.isArray(grant.newMilestones) && grant.newMilestones.length > 0) {
    return grant.newMilestones.map((n) => Number(n)).filter((n) => Number.isInteger(n) && n > 0);
  }
  if (grant.leveledUp !== true) {
    return [];
  }
  const levelBefore = Number(grant.levelBefore) || 1;
  const levelAfter = Number(grant.levelAfter) || levelBefore;
  if (levelAfter <= levelBefore) {
    return [];
  }
  return MILESTONE_LEVELS.filter((ml) => ml > levelBefore && ml <= levelAfter);
}
